import { useCallback } from 'react';

import { isUserReviewerForCustomer } from 'src/data/user';
import { useCustomerActions } from 'src/store/customer';
import { useUserActions } from 'src/store/user';
import { useWorkspaceActions } from 'src/store/workspace';

export const useGetCommonEventAuthAttributes = () => {
  const userActions = useUserActions();
  const customerActions = useCustomerActions();
  const workspaceActions = useWorkspaceActions();

  return useCallback(() => {
    const userId = userActions.getCurrentUserId();
    // A reviewer's customer never loads. Authenticated events still need the id of the selected account.
    const selectedCustomerId = customerActions.getSelectedCustomerId();
    const customerId =
      selectedCustomerId !== null &&
      isUserReviewerForCustomer(userActions.getCurrentUser(), selectedCustomerId)
        ? selectedCustomerId
        : customerActions.getCurrentCustomerId();

    // Generally we should not have "workspace" selected when there is no customer, but in some cases we are not clearing the "workspace" store when "customer" gets changed
    // TODO: we should fix that, but for now we need to handle this case
    const workspaceId = customerId ? workspaceActions.getCurrentWorkspaceId() : null;

    return {
      userId,
      customerId,
      workspaceId,
    };
  }, [userActions, customerActions, workspaceActions]);
};
